module.exports = __webpack_public_path__ + "static/team2-7d12d6272d82778a4bed1feeb8766044.jpg";